/** Returns a displayable category name, or null when unset / WordPress default. */
export function displayCategoryName(categoryName: string | null | undefined): string | null {
    if (!categoryName || !categoryName.trim()) {
        return null;
    }
    if (categoryName.trim().toLowerCase() === 'uncategorized') {
        return null;
    }
    return categoryName;
}
